import { useRef } from "react";
import Button from "../../../../components/Buttons/Button";
import CustomModal from "../../../../components/Modal/CustomModal";
import useReactGASend from "../../../../hooks/useReactGASend";

const FileUploadModal = ({ isOpen, onRequestClose, onHandleAgree }) => {
  const { makeEventTrackFn } = useReactGASend();
  // const fileInputRef = useRef(null);

  const handleAllow = () => {
    onRequestClose();
    onHandleAgree(true);

    makeEventTrackFn({
      category: "event",
      action: "파일 업로드 권한 허용",
    });
    // fileInputRef.current.click();
  };

  return (
    <>
      <CustomModal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        contentLabel="파일업로드 동의 모달"
      >
        <h3 className="mb-6 text-2xl font-semibold text-center">
          사진 파일 업로드 권한을 <br /> 허용하시겠습니까?
        </h3>
        {/* <div className="flex items-center justify-center gap-3 mb-5">
          <div className="flex items-center justify-center rounded-2xl w-14 h-14 bg-neutral-100">
            <FaImage className="text-2xl text-neutral-500" />
          </div>
          <div>
            <p className="text-lg font-semibold">파일 업로드</p>
            <p className="font-medium text-neutral-400">사진파일 업로드</p>
          </div>
        </div> */}
        <p className="mb-8 font-medium text-center text-neutral-400 break-keep">
          권한 제한시 서비스 이용이 제한됩니다.
        </p>
        <div className="flex gap-2">
          <Button size="sm" cancle onClick={onRequestClose}>
            취소
          </Button>
          <Button size="sm" onClick={handleAllow}>
            허용
          </Button>
        </div>
      </CustomModal>
    </>
  );
};

export default FileUploadModal;
